import React from 'react';
import PropTypes from 'prop-types';
import { TimerNumAndText } from './TimerNumAndText';
import helpers from '../../helpers/countdownHelper';
import './timer-nums-over-text.scss';

const TimerNumsOverText = ({ timeStringAndMessaging }) => {
  const {
    timerDays,
    timerHours,
    timerMinutes,
    timerSeconds,
    daysText,
    hoursText,
    minuteText,
    secondsText,
  } = helpers.getTextBelow(timeStringAndMessaging.timeString);

  return (
    <div className="timer-nums-over-text">
      {timerDays && (
        <>
          <TimerNumAndText timerNums={timerDays} timerText={daysText} />
          <div className="timer-nums-over-text__timer">:</div>
        </>
      )}
      <TimerNumAndText timerNums={timerHours} timerText={hoursText} />
      <div className="timer-nums-over-text__timer">:</div>
      <TimerNumAndText timerNums={timerMinutes} timerText={minuteText} />
      {!timerDays && (
        <>
          <div className="timer-nums-over-text__timer">:</div>
          <TimerNumAndText timerNums={timerSeconds} timerText={secondsText} />
        </>
      )}
    </div>
  );
};

TimerNumsOverText.displayName = 'TimerNumsOverText';

TimerNumsOverText.propTypes = {
  timeStringAndMessaging: PropTypes.shape({
    messagingString: PropTypes.string,
    /* eslint-disable-next-line react/forbid-prop-types */
    timeString: PropTypes.any,
  }).isRequired,
};

export default TimerNumsOverText;
